// Package Imports
import { queryOptions, useMutation } from '@tanstack/react-query'

// Core Imports
import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'
import type { TAdminListParams } from '@/core/lib/table-query'

// Module Imports
import {
  getModeratorList,
  getPlayerDetail,
  getPlayerList,
  sendPlayerNotification,
  updatePlayerRoles,
} from '@/modules/player/player.service'
import type {
  TSendPlayerNotificationRequest,
  TUpdatePlayerRolesRequest,
} from '@/modules/player/player.types'

export const playerListQueryOptions = (params: TAdminListParams) =>
  queryOptions({
    queryKey: ['playerList', params],
    queryFn: () => getPlayerList(params),
  })

export const playerDetailQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['playerDetail', id],
    queryFn: () => getPlayerDetail(id),
  })

export const moderatorListQueryOptions = () =>
  queryOptions({
    queryKey: ['moderatorList'],
    queryFn: () => getModeratorList(),
  })

export function useUpdatePlayerRoles({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TUpdatePlayerRolesRequest>) {
  return useMutation<void, TResponseError, TUpdatePlayerRolesRequest>({
    mutationFn: updatePlayerRoles,
    onSuccess,
    onError,
  })
}

export function useSendPlayerNotification({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TSendPlayerNotificationRequest>) {
  return useMutation<void, TResponseError, TSendPlayerNotificationRequest>({
    mutationFn: sendPlayerNotification,
    onSuccess,
    onError,
  })
}
